var React = require('react');

function ArrowReturn (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M20 6V10.5L10 4.5L0 10.5L5.96244e-08 6L10 1.90735e-06L20 6Z","key":0}),React.createElement("path",{"d":"M12 30L12 4L8 4L8 34H20V30H12Z","key":1})]);
}

ArrowReturn.defaultProps = {"width":"20","height":"36","viewBox":"0 0 20 36"};

module.exports = ArrowReturn;

ArrowReturn.default = ArrowReturn;
